import Reviews from "@commons/store-setup/individual-store/Reviews";

const StoreReviewsPage = () => <Reviews />;

export default StoreReviewsPage;
